module.exports = __webpack_public_path__ + "static/media/svetielko.0e3ecbed.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/svetielko.png
// module id = 439
// module chunks = 0